<div fxFlex="100" class="mt-12" fxLayout="row wrap" fxLayoutAlign="start center" *transloco="let translate">
  <button egButton egType="round" egButtonSize="small" class="mx-10" (click)="onSelectAll()">
    {{ translate('action.selectAll') }}
  </button>
  <button egButton egType="round" egButtonSize="small" egStyle="secondary" class="mx-10" (click)="onSelectNone()">
    {{ translate('action.selectNone') }}
  </button>
  <span class="multi-select multi-select--gray px-10"> {{ translate('action.results') }}: {{ items.length }} </span>
  <span class="multi-select multi-select--gray px-10"> {{ translate('action.selected') }}: {{ selectedItems.length }} </span>
  <button egButton egType="round" egButtonSize="small" class="ml-10" (click)="onEditOpen()" [disabled]="selectedItems.length === 0">
    {{ translate('action.editMultiple') }}
  </button>
</div>
